import React, { useState, useCallback } from 'react';
import { View, TextInput, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Brand, Neutrals } from '@/constants/theme';

export interface AddItemInputProps {
  onAddItem: (itemName: string) => void | Promise<void>;
  placeholder?: string;
  disabled?: boolean;
}

export function AddItemInput({
  onAddItem,
  placeholder = 'Add item...',
  disabled = false,
}: AddItemInputProps) {
  const [itemName, setItemName] = useState('');

  const handleSubmit = useCallback(() => {
    const trimmed = itemName.trim();
    if (!trimmed || disabled) return;
    onAddItem(trimmed);
    setItemName('');
  }, [itemName, disabled, onAddItem]);

  return (
    <View style={styles.container}>
      <View style={[styles.inputWrapper, disabled && styles.inputDisabled]}>
        <View style={styles.iconWrapper}>
          <Ionicons name="add" size={18} color={Neutrals.white} />
        </View>
        <TextInput
          style={styles.input}
          placeholder={placeholder}
          placeholderTextColor={Neutrals.textMuted}
          value={itemName}
          onChangeText={setItemName}
          onSubmitEditing={handleSubmit}
          returnKeyType="done"
          blurOnSubmit={false}
          autoCapitalize="sentences"
          autoCorrect={true}
          editable={!disabled}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    minWidth: 0,
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  inputWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Neutrals.white,
    borderRadius: 16,
    borderWidth: 2,
    borderStyle: 'dashed',
    borderColor: Brand.accent,
    paddingHorizontal: 12,
    paddingVertical: 4,
    gap: 12,
  },
  iconWrapper: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: Brand.accent,
    alignItems: 'center',
    justifyContent: 'center',
  },
  input: {
    flex: 1,
    minWidth: 0,
    fontSize: 16,
    paddingVertical: 10,
    color: Neutrals.textPrimary,
  },
  inputDisabled: {
    opacity: 0.7,
  },
});
